import { createRoot } from "react-dom/client";
import { SeerezCaseDetails } from "../components/SeerezCaseDetails";

export function initSeerezDetails() {
  const container = document.getElementById("seerez-details");

  if (container) {
    const root = createRoot(container);
    const dataset = container.dataset;
    const pharmacyProviderInfo = JSON.parse(dataset.pharmacyProviderInfo);
    const isPharmacyOwnedByClinic = dataset.isPharmacyOwnedByClinic === "true";

    const testInfo = {
      name: dataset.testName,
      icd10Codes: dataset.icd10Codes?.split(","),
      cptCodes: JSON.parse(dataset.cptCodes),
      labName: dataset.labName,
      coverageType: dataset.insuranceCoverageType,
      orderId: dataset.orderId,
      dateOfService: dataset.insuranceDateOfService,
    };

    const practiceInfo = {
      name: dataset.providerName,
      practiceName: dataset.providerPracticeName,
      clinicId: dataset.providerClinicId,
      npi: dataset.providerNpi,
      enrolled: dataset.providerEnrolled,
    };

    const primaryInsuranceInfo = {
      name: dataset.insuranceName,
      verifiedName: dataset.insuranceVerifiedName,
      planName: dataset.insurancePlanName,
      planType: dataset.insuranceVerifiedPlanType,
      effectiveDate: dataset.insuranceEffectiveDate,
      policyEndDate: dataset.insurancePolicyEndDate,
      memberId: dataset.insuranceMemberId,
      activeCoverage: dataset.insuranceActiveCoverage,
      fundingType: dataset.insuranceFundingType,
      employerName: dataset.insuranceEmployerName,
      payorPhone: dataset.insurancePayorPhone,
      benefitsVerified: dataset.insuranceBenefitsVerified,
      groupId: dataset.insuranceGroupId,
      dateVerified: dataset.insuranceDateVerified,
    };

    const paOtherInfo = {
      authorizationNumber: dataset.authorizationNumber,
      denialNumber: dataset.denialNumber,
      authorizationDate: dataset.authorizationDate,
      authorizationEffectiveDate: dataset.authorizationEffectiveDate,
      authorizationExpirationDate: dataset.authorizationExpirationDate,
      uhcSrn: dataset.uhcSrn,
      claimNumber: dataset.claimNumber,
      serviceDate: dataset.serviceDate,
      collectionDate: dataset.collectionDate,
    };

    const pharmacyOtherInfo = {
      dateOfService: dataset.insuranceDateOfService,
      orderId: dataset.orderId,
      icdCodes: dataset.icd10Codes,
      collectionDate: dataset.collectionDate,
    };

    const pharmacyPracticeInfo = {
      practiceName: dataset.labName,
      phone: pharmacyProviderInfo.phone,
      faxNumber: pharmacyProviderInfo.fax,
      addressInfoSnowflake: pharmacyProviderInfo.address,
      npi: pharmacyProviderInfo.provider_npi,
      siteService: pharmacyProviderInfo.site_of_service,
      coverageType: dataset.insuranceCoverageType,
      taxId: pharmacyProviderInfo.tax_id,
    };

    root.render(
      <SeerezCaseDetails
        test={testInfo}
        practice={practiceInfo}
        primaryInsuranceInfo={primaryInsuranceInfo}
        paOtherInfo={paOtherInfo}
        isPharmacyOwnedByClinic={isPharmacyOwnedByClinic}
        pharmacyPracticeInfo={pharmacyPracticeInfo}
        pharmacyOtherInfo={pharmacyOtherInfo}
      />
    );
  }
}
